const offers=[

    {
        id: 1,
        image : 'https://i.ibb.co/rfdbYq9/y1.png',
        day: 'Friday- Online class',
        time: '9.00 am - 11 am'
    },
    {
        id: 2,
        image : 'https://i.ibb.co/GRRPMky/y2.png',
        day: 'Friday- Online class',
        time: '9.00 am - 11 am'
    },
    {
        id: 3,
        image : 'https://i.ibb.co/BVwbbrm/y3.png',
        day: 'Friday- Online class',
        time: '9.00 am - 11 am'
    },
    {
        id: 4,
        image : 'https://i.ibb.co/GRRPMky/y2.png',
        day: 'Friday- Online class',
        time: '9.00 am - 11 am'
    },
    {
        id: 5,
        image : 'https://i.ibb.co/BVwbbrm/y3.png',
        day: 'Friday- Online class',
        time: '9.00 am - 11 am'
    },

];
 
export default offers;